const GRADIENTE = {
  backgroundImage: "linear-gradient(90deg, #1B2B4B 0%, #00B4CC 100%)",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  color: "transparent",
};

const TAMANOS = {
  sm: { mayus: "text-[24px]", minus: "text-[16px]", fichaje: "text-[13px]" },
  md: { mayus: "text-[34px]", minus: "text-[22px]", fichaje: "text-[18px]" },
  lg: { mayus: "text-[44px]", minus: "text-[28px]", fichaje: "text-[23px]" },
};

export const LogoFichaje = ({ size = "md", className = "", testid = "logo-fichaje" }) => {
  const t = TAMANOS[size];
  return (
    <span role="img" aria-label="NuvliPro FICHAJE" data-testid={testid}
      className={`inline-flex items-baseline gap-2 bg-white font-bold leading-none select-none whitespace-nowrap ${className}`}
      style={{ fontFamily: "Montserrat, sans-serif" }}>
      <span aria-hidden="true" className="inline-flex items-baseline">
        <span className={`${t.mayus} text-[#1B2B4B]`}>N</span>
        <span className={`${t.minus} inline-block`} style={GRADIENTE}>uvli</span>
        <span className={`${t.mayus} text-[#1B2B4B]`}>P</span>
        <span className={`${t.minus} inline-block`} style={GRADIENTE}>ro</span>
      </span>
      <span aria-hidden="true" className={`${t.fichaje} text-[#1B2B4B] tracking-[0.12em]`}>FICHAJE</span>
    </span>
  );
};
